import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getLifeplaceProducts} from '../../services/getLifeplaceProducts';

export const useLifeplaceProductsQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.LIFEPLACE_PRODUCTS],
		queryFn: ({signal}) => getLifeplaceProducts({id: 147, quantity: 8, page: 1, signal}),
		retry: 2,
	});
